module.exports = __webpack_public_path__ + "static/media/machine-img-v.d3a06b58.png";